import client from './http';

const config = {
  headers: {
    'Content-Type': 'application/json',
  },
};

const configFile = {
  headers: {
    'Content-Type': 'multipart/form-data',
  },
};

export const getSearchedReceivableTransaction = (query) => {
  if (query === '') {
    return client.get('receivabletransactions', config);
  }
  return client.get(`receivabletransactions?${query}`, config);
};

export const getSpecificRTData = id => client.get(`receivables/${id}`, config);

export const addRTReceipt = (id, data) => client.post(`receivabletransactions/${id}/receipts/`, data, configFile);

export const deleteReceivableTransaction = id => client.delete(`receivabletransactions/${id}`, config);

export const addNewReceivableTransaction = (id, data) => client.patch(`receivables/${id}/`, data, config);

export const setRTPaymentStatus = data => client.post(`setReceivablePaymentStatus/${data.id}`, data, config);

export const addRTComment = data => client.post(`receivables/${data.rtId}/comments/`, { text: data.comment, mentions: data.mentions }, config);

export const updateRTPaymentAmount = data => client.patch(`receivabletransactions/${data.id}/`, { amount: data.amount }, config);

export const updateRTPaymentDue = data => client.patch(`receivabletransactions/${data.id}/`, { due: data.due }, config);

export const updateRTPaymentDate = data => client.post(`updateReceivablePaymentDate/${data.id}`, data.date, config);

export const createReceivable = data => client.post('receivables/', data, config);

export const ackPayment = data => client.post(`receivabletransactions/${data.paymentId}/ackPayment/`, config);

export const undoRTConfirmation = data => client.post(`receivabletransactions/${data.paymentId}/undoPayment/`, config);

export const deleteRTPaymentReceipt = (rtId, receiptId) => client.delete(`receivabletransactions/${rtId}/receipts/${receiptId}`, config);

export const confirmRTPaymentReceipt = (rtId, receiptId) => client.post(`receivabletransactions/${rtId}/receipts/${receiptId}/ackPayment/`, config);

export const undoConfirmRTPaymentReceipt = (rtId, receiptId) => client.post(`receivabletransactions/${rtId}/receipts/${receiptId}/undoPayment/`, config);



// WEBPACK FOOTER //
// ./src/services/receivables.js